import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '../IconButton';
import useStyles from './styles';

import editBtn from '../../../../resources/edit-btn@1x.png';


const EditButton = ({ onClick }) => {
  const classes = useStyles();
  return (
    <IconButton
      source={editBtn}
      onClick={onClick}
      alt="edit"
      iconClass={classes.button}
    />
  );
};

EditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default EditButton;
